<script type="ts">
  import Navbar from "./components/navbar/Navbar.svelte";
  import OverviewPage from "./pages/OverviewPage.svelte";
  import { gameState } from "./store";
  import NewGamePage from "./pages/NewGamePage.svelte";
  import GamePage from "./pages/GamePage.svelte";
</script>

<main>
  <Navbar />
  <div class="m-3">
    {#if $gameState.currentGame === null}
      <div>
        <OverviewPage />
      </div>
    {:else if $gameState.currentGame === -1}
      <div>
        <NewGamePage />
      </div>
    {:else}
      <div>
        <GamePage />
      </div>
    {/if}
  </div>
</main>
